import Vue from 'vue'
import moment from 'moment'
import formatPrice from '../helpers/format-price'

Vue.filter('date', (value) => {
	if (value) return moment(String(value)).format('DD/MM/YYYY')
	else return ''
})

Vue.filter('time', (value) => {
	if (value) return moment(String(value)).format('HH:mm [hs]')
	else return ''
})

Vue.filter('datetime', (value) => {
	if (value) return moment(String(value)).format('DD/MM/YYYY HH:mm [hs]')
	else return ''
})

Vue.filter('truncate', (value, len, overflowText = '...') => {
	value = String(value || '').trim()
	if (value.length <= len) return value
	return value.slice(0, len - overflowText.length) + overflowText
})

Vue.filter('price', (value, opts = {}) => formatPrice(value || 0, opts))

Vue.filter('discountPct', (value) => {
	let pct = Number(value)
	return pct ? Math.max(1, Math.round(pct)) : 0
})
